import React, { useEffect, useState, useRef } from "react";
import "./iplbattle.css";
import useUserInfo from "../../../Hooks/useUserInfo";
import { motion } from "framer-motion";
import { fanRallyApi, getCurrentBattleScore, UpdateSqaudRunsApi, UserIplRunData } from "../../../apis/iplBattle";
import { CountdownTimer, Images, ipl_BoosterDuration, logoMap2 } from "../../../helpers/helpers";
import MatchScheduleList from "./matchsceduleList";
import Swal from "sweetalert2";
import tapSound from "../../../assets/audio/taps.wav";
import { Clock } from "lucide-react";

import { logPageView } from "../../../components/analytics";
import CricketGame from "./cricketGame";
const Iplwar = (props) => {
  const { userDetails, watchScreen, updatewatchScreenInfo, updateUserInfo } =
    useUserInfo();
  const [score, setScore] = useState(0);
  const [displayScore, setDiplaySetScore] = useState(0);
  const [ballCount, setBallCount] = useState(0);
  const [isGameActive, setIsGameActive] = useState(true); // Add game state
  // Ensure runs are always even
  const IsPointsReach =
    watchScreen?.LoginMessage ==
      "You have already reached the maximum rewards limit"
      ? true
      : false;
  const CurrentData = watchScreen?.currentBattleDetails;
  const CurrentMatch = watchScreen?.current_battle;
  const CurrentTeams = CurrentMatch?.teams;
  const selectedTeam = CurrentTeams?.find(
    (team) => team.teamId === CurrentData?.selectedTeamId
  );
  const selectedTeamName = selectedTeam
    ? selectedTeam?.teamName
    : "Team Not Found";

  const UnselectedTeam = CurrentTeams?.find(
    (team) => team.teamId !== CurrentData?.selectedTeamId
  );
  useEffect(() => {
    logPageView("UFW GAME PAGE", "UFW GAME PAGE");
  }, []);

  const [totalRuns, setTotalRuns] = useState(CurrentData?.userRuns); // Store overall runs
  const [balls, setBalls] = useState(CurrentData?.userPlayedBallsCount);

  const ComboPercent = 0.25
  const SquadMultiPercent = 0.10
  const [battleScore, setBattleScore] = useState(null);
  const iplBoosterPopup = props?.iplBoosterPopup;
  const setIplBoosterPopup = props?.setIplBoosterPopup;


  const BoosterName = watchScreen?.ipl_boosterDetails?.name;

  const scrollableRef = useRef(null);

  const goToThePage = (component, name) => {
    updateUserInfo((prev) => {
      return {
        ...prev,
        ...{
          currentComponent: component,
          currentComponentText: name,
          lastComponent: userDetails?.currentComponent,
          lastComponentText: userDetails?.currentComponentText,
          centerCount: userDetails?.centerCount + 1,
        },
      };
    });
  };

  const [watchSeconds, setWatchSeconds] = useState(0);
  const scoreRef = useRef(score);
  const ballCounRef = useRef(ballCount);
  const lastSentScoreRef = useRef(0);

  // Add effect to reset lastSentScoreRef when game becomes inactive
  useEffect(() => {
    if (!isGameActive) {
      lastSentScoreRef.current = 0;
      scoreRef.current = 0;
      setScore(0);
    }
  }, [isGameActive]);

  useEffect(() => {
    if (score != 0 && scoreRef.current != score) {
      scoreRef.current = score;
    }

    ballCounRef.current = ballCount
  }, [score, ballCount]);
  useEffect(() => {
    const apiInterval = setInterval(() => {
      setWatchSeconds(prev => {
        const currentScore = scoreRef.current;
        const currentBalls = ballCounRef.current;
        const scoreDiff = currentScore - lastSentScoreRef.current;

        let ScoreMulti = scoreDiff;
        if (BoosterName === "2x") {
          ScoreMulti = scoreDiff * 2;
        } else if (BoosterName === "3x") {
          ScoreMulti = scoreDiff * 3;
        } else if (BoosterName === "4x") {
          ScoreMulti = scoreDiff * 4;
        } else if (BoosterName === "5x") {
          ScoreMulti = scoreDiff * 5;
        } else if (BoosterName === "comboChain") {
          ScoreMulti = scoreDiff + (scoreDiff * ComboPercent);
        } else if (BoosterName === "squadMultiplier") {
          ScoreMulti = scoreDiff + (scoreDiff * SquadMultiPercent);
        }
        const BoosterPoints = BoosterName === "comboChain"
          ? Math.floor(scoreDiff * ComboPercent)
          : BoosterName === "squadMultiplier"
            ? Math.floor(scoreDiff * SquadMultiPercent)
            : ScoreMulti - scoreDiff;

        const args = {
          calculatedRuns: Math.floor(ScoreMulti),
          ball: currentBalls,
          boosterName: BoosterName,
          BoosterCount: null,
          BoosterPoints: watchScreen?.ipl_booster ? BoosterPoints : null
        }
        const FanRallyargs = {
          userRuns: Math.floor(ScoreMulti),
          count: 0
        }


        // ✅ Skip API call if booster is active
        if (
          isGameActive &&
          scoreDiff >= -5 &&
          scoreRef.current !== 0
        ) {
          callApi(args);
          if (BoosterName=="fanRally"){
          callFanRallyApi(FanRallyargs)}
          lastSentScoreRef.current = currentScore;

          // Reset score after sending
          scoreRef.current = 0;
          setScore(0);
        }

        return 0;
      });
    }, 10000);

    return () => {
      clearInterval(apiInterval);
    };
  }, [isGameActive, watchScreen?.ipl_booster, watchScreen?.ipl_boosterDetails]);
  // Add isGameActive to dependencies


  const boostIntervalRef = useRef(null);
  const boostref = useRef(false);
  const duration = ipl_BoosterDuration[BoosterName];

  useEffect(() => {
    const args = {
      calculatedRuns: 0,
      ball: 0,
      boosterName: BoosterName,
      BoosterCount: watchScreen?.ipl_boosterDetails?.count,
    }
    const fanRally = {
      userRuns: 1,
      count: 1
    }
    if (
      watchScreen.ipl_booster &&
      watchScreen.ipl_boosterSec > 0 &&
      !boostref.current // 🟢 Prevent multiple intervals
    ) {
      boosterInterval();
      callApi(args);
       if (BoosterName=="fanRally"){
      callFanRallyApi(fanRally)}
    }
    if (watchScreen?.ipl_boosterSec == 0) {
      updatewatchScreenInfo(prev => ({
        ...prev,
        ipl_booster: false,
        ipl_boosterDetails: {},
        ipl_boosterSec: duration,
        squadCode: ''
      }));
    }
  }, [watchScreen]);

  const boosterInterval = () => {


    boostref.current = true;

    boostIntervalRef.current = setInterval(() => {
      updatewatchScreenInfo((prev) => {
        const newBoosterSec = Math.max(prev.ipl_boosterSec - 1, 0);

        if (newBoosterSec === 0) {
          clearInterval(boostIntervalRef.current);
          boostref.current = false;

          // ✅ Call API with stored multiplied score and balls
          // callApi(ScoreMulti, currentBalls);


        }

        return {
          ...prev,
          ipl_boosterSec: newBoosterSec,

        };
      });
    }, 1000);
  };

  const callApi = async (args) => {
    const data = {
      // userWatchPoints: IsPointsReach ? 0 : watchSeconds,
      userWatchPoints: IsPointsReach ? 0 : 0,
      userTapPoints: 0,
      selectedCard: CurrentData?.selectedCard,
      selectedTeamId: CurrentData?.selectedTeamId,
      userRuns: args?.calculatedRuns,
      battleId: CurrentData?.battleId,
      userPlayedBalls: !args?.ball ? 0 : args?.ball,
      ...(BoosterName !== "fanRally" && {
        iplBoosters: [
          {
            type: args?.boosterName ? BoosterName : '',
            boosterPoints: args?.BoosterPoints ? args?.BoosterPoints : 0,
            count: args?.BoosterCount ? watchScreen?.ipl_boosterDetails?.count : ''
          }
        ]
      })
    };

    const squadData = {
      userRuns: args?.calculatedRuns,
    }
    try {
      const response = await UserIplRunData(data);
      const SquadResponse = await UpdateSqaudRunsApi(squadData);

      if (response) {

        updatewatchScreenInfo((prev) => ({
          ...prev,
          totalReward: response?.scoreDetails?.balanceRewards,
          // ipl_booster:false,
          // ipl_boosterSec:30,
          // ipl_boosterDetails:{}
        }));

        setBalls(response?.scoreDetails?.userPlayedBallsCount);

        setTotalRuns(response?.scoreDetails?.userRuns);
        setScore(0);
        // setRuns(0);

      }
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  const callFanRallyApi = async (args) => {
    const data = {
      "userRuns": args?.userRuns,
      "squadCode": watchScreen?.squadCode,
      "boosterType": "fanRally",
      "count": args?.count
    }
    try {
      const response = await fanRallyApi(data);
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  useEffect(() => {
    // Function to fetch battle score
    const fetchBattleScore = async () => {
      const data = await getCurrentBattleScore(
        CurrentData?.battleId || CurrentMatch?._id
      );
      if (data) {
        setBattleScore(data);
      }
    };

    // Call API every 10 seconds
    const intervalId = setInterval(() => {
      fetchBattleScore();
    }, 10000);

    // Initial API call when component mounts
    fetchBattleScore();

    // Cleanup interval on component unmount
    return () => clearInterval(intervalId);
  }, [CurrentData?.battleId]);
  const TeamScore = battleScore?.teamScores;
  const selectedTeamId = TeamScore?.find(
    (team) => team.teamId === CurrentData?.selectedTeamId
  );

  const UnselectedTeamId = TeamScore?.find(
    (team) => team.teamId !== CurrentData?.selectedTeamId
  );
  const teamScore1 = selectedTeamId?.teamScores;
  const teamScore2 = UnselectedTeamId?.teamScores;
  const totalTeamScore = teamScore1 + teamScore2;


  const formatScore = (score) => {
    if (score >= 10000) {
      return (score / 1000).toFixed(1) + "k";
    }
    return score;
  };

  // Preload videos


  const TotalScore = watchScreen?.totalReward + scoreRef.current
  const MyRuns = (displayScore || 0) + (Number(CurrentData?.userRuns) || 0);

  return (
    <div
      className="menupointer"
      style={{ height: "100%", width: "100%", pointerEvents: "none" }}
    >
      <div
        className="row level-div text-center"
        style={{
          margin: "13% 9% 0%",
        }}
      >
        <div className="row iplbattleflex">
          <div className="col-3">
            <div className="favteam text-uppercase">
              <img src={selectedTeam?.teamLogo} />
              <div className="d-flex align-items-center justify-content-center">
                <h3 class="teamname"> {selectedTeam?.teamName}</h3>
                <div className="selected-team-icon">
                  <i className="fas fa-check-circle"></i>
                </div>
              </div>
              <h3 className="battle-end battle1">
                {selectedTeamId?.teamScores &&
                  formatScore(selectedTeamId.teamScores)}
              </h3>
            </div>
          </div>
          <div className="col-6 gridbattle">
            <div>
              {/* <p className="battle-time">MY RUNS</p> */}
              <h3 className="battle-end1">
                MY RUNS {Math.floor( MyRuns)}
              </h3>{" "}
              <h3 className="battle-end txt-color flexipl1" style={{ fontSize: "13px" }}>
                <img
                  src={Images?.memeLogo}
                  alt="Meme TV"
                  style={{
                    width: "20px"
                  }}
                />   {formatScore(TotalScore)}
              </h3>{" "}
            </div>
            <p className="battle-runs text-uppercase flexipl">
              <Clock size={14} className="text-gray-900" />
              <CountdownTimer enddate={CurrentData?.battleEndDate} /></p>
            <div className="iplflex">
            </div>
          </div>

          <div className="col-3">
            <div className="hateteam text-uppercase">
              {/* <img src={UnselectedTeam?.teamLogo} /> */}
              <img
                src={
                 UnselectedTeam?.teamLogo
                }
              />
              <h3 className="teamname">{UnselectedTeam?.teamName}</h3>
              <h3 className="battle-end battle2">
                {UnselectedTeamId?.teamScores &&
                  formatScore(UnselectedTeamId.teamScores)}
              </h3>
            </div>
          </div>
        </div>
        {/* 
        <div className="row">
          <div className="col-2">
            <div className="token-div">
              <p
                style={isTapping ? styles.formMeterText : {}}
                className="token-mint"
              >
                FORM METER
              </p>
              <p
                className={`formeter ${
                  isFormMeterAnimating ? "animating" : ""
                }`}
              >
                <Speedometer formMeter={formMeter} />
              </p>
            </div>
          </div>
          <div className="col-8 points">
            <h2>
              <img style={{ width: "30px" }} src={memetv} alt="Meme TV" />
              <span className="txt-color ml-5">{Math.floor(TotalScore)}</span>
            </h2>
          </div>
          <div className="col-2">
            <div className="token-div">
              <p className="token-mint1 text-uppercase">Next Ball</p>
              <p className="earn-p">{nextApiTimeLeft}</p>
            </div>
          </div>
        </div> */}
        {/* <div className="row disflex mt-1">
          <div className="col-5">
            <div className="distance1">
              <img src="https://d1ccopf5cw1hft.cloudfront.net/s3data/distance.png" />
              <div className="distance">
                <h4 className="text-uppercase">distance meter</h4>
                {exactTimer <= 5 ? (
                  <AnimatedRuns runs={runs} trigger={true} />
                ) : (
                  <p>{runs}</p>
                )}
              </div>
            </div>
          </div>
          <div className="col-4 position-relative">
            <div className="distance1">
              <div className="distancebal">
                <h4 className="text-uppercase">Total Balls</h4>
                <p>{balls}/240</p>
              </div>
              <img
                style={{ right: "-8px" }}
                src="https://d1ccopf5cw1hft.cloudfront.net/s3data/totalball.png"
              />
            </div>
          </div>
        </div> */}
      </div>
      {/* <div className="row level-div text-center" style={{ margin: "55px 35px" }}>
        <h3>Form Meter: {formMeter} Points</h3>
      </div> */}
      <div
        className="row"
        style={{
          height: "500px",
        }}

      >
        <div
          className="col-12"
          style={{
            zIndex: "-1",
          }}
        >
          <>
            <div class="image-containercricket">
              <div className="charactercri">
                <CricketGame
                  score={score}
                  setDiplaySetScore={setDiplaySetScore}
                  setScore={setScore}
                  ballCount={ballCount}
                  setBallCount={setBallCount}
                  setIsGameActive={setIsGameActive} // Pass the game state setter
                  iplBoosterPopup={iplBoosterPopup}
                  isGameActive={isGameActive}
                  setIplBoosterPopup={setIplBoosterPopup}
                />
              </div>
            </div>
          </>


        </div>
      </div>
      <div ref={scrollableRef}></div>
    </div>
  );
};

export default Iplwar;